const appConfig = {
  api_key: "60f291aa46ea447060f291aa46ea447019d83ba30be508e419d83ba30be508e4",
  abdm_env: "@abdm",
};

export const key = "PathkindAbha1234";
export const iv = "PathkindAbhaabcd";
export const timerCount = 60;

export default appConfig;
